import { createGlobalStyle } from 'styled-components';
import img from './hM9rFe.jpg';

const SettingsPageStyle = createGlobalStyle`
body {
    background: url('${img}') no-repeat center center fixed;
    background-size: cover;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

.settings-page {
    min-height: calc(100vh - 80px);
    padding: 40px 20px 80px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.settings-page::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 0;
}

.settings-container {
    position: relative;
    z-index: 1;
    max-width: 700px;
    width: 100%;
}

.settings-header {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 16px;
    padding: 30px;
    margin-bottom: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
    text-align: center;
}

.back-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: #fff;
    border: 2px solid #6b7280;
    border-radius: 8px;
    color: #6b7280;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 20px;
}

.back-button:hover {
    background: #6b7280;
    color: #fff;
    transform: translateX(-4px);
}

.settings-header h1 {
    font-size: 32px;
    font-weight: bold;
    color: #1f2937;
    margin: 0 0 8px;
}

.settings-header p {
    font-size: 16px;
    color: #6b7280;
    margin: 0;
}

.settings-options {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.settings-option {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 12px;
    padding: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    border-left: 4px solid var(--option-color, #3b82f6);
}

.settings-option:hover {
    transform: translateX(4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.settings-option.active {
    transform: translateX(0);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

.option-header {
    display: flex;
    align-items: center;
    gap: 20px;
}

.option-icon {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.option-icon svg {
    width: 100%;
    height: 100%;
}

.option-info {
    flex: 1;
}

.option-info h3 {
    font-size: 20px;
    font-weight: bold;
    color: #1f2937;
    margin: 0 0 6px;
}

.option-info p {
    font-size: 15px;
    color: #6b7280;
    margin: 0;
}

.avatar-section {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 2px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.avatar-preview {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    border: 4px solid #ec4899;
    box-shadow: 0 4px 15px rgba(236, 72, 153, 0.3);
}

.avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.avatar-placeholder {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #ec4899, #f472b6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.avatar-placeholder svg {
    width: 60px;
    height: 60px;
}

.avatar-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
}

.avatar-upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: #ec4899;
    color: #fff;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
}

.avatar-upload-btn:hover {
    background: #db2777;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(236, 72, 153, 0.4);
}

.avatar-remove-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: #fff;
    color: #ef4444;
    border: 2px solid #ef4444;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.avatar-remove-btn:hover {
    background: #ef4444;
    color: #fff;
}

.avatar-note {
    font-size: 13px;
    color: #6b7280;
    margin: 0;
}

.option-form {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 2px solid #e5e7eb;
}

.option-form input[type="text"],
.option-form input[type="email"],
.option-form input[type="password"] {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    font-size: 16px;
    font-family: Arial, sans-serif;
    margin-bottom: 12px;
    box-sizing: border-box;
    transition: all 0.3s ease;
}

.option-form input:focus {
    outline: none;
    border-color: var(--option-color);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.checkbox-group {
    padding: 16px;
    background: #f3f4f6;
    border-radius: 8px;
    margin-bottom: 16px;
}

.checkbox-group.danger {
    background: #fee2e2;
    border: 2px solid #ef4444;
}

.checkbox-group label {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.checkbox-group span {
    font-size: 15px;
    color: #1f2937;
    font-weight: 500;
}

.form-divider {
    margin: 20px 0;
    padding: 16px;
    background: #fef3c7;
    border-left: 4px solid #f59e0b;
    border-radius: 8px;
}

.form-divider p {
    margin: 0;
    font-size: 14px;
    color: #92400e;
    font-weight: 600;
}

.captcha-container {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.submit-button {
    width: 100%;
    padding: 14px;
    background: #3b82f6;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.submit-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
    filter: brightness(1.1);
}

.submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .settings-page {
        padding: 20px 15px 80px;
    }

    .settings-header {
        padding: 20px;
    }

    .settings-header h1 {
        font-size: 26px;
    }

    .settings-option {
        padding: 20px;
    }

    .option-icon {
        width: 40px;
        height: 40px;
    }

    .option-info h3 {
        font-size: 18px;
    }

    .option-info p {
        font-size: 14px;
    }
}
`;

export default SettingsPageStyle;
